import { render, staticRenderFns } from "./WarehouseTransfer.vue?vue&type=template&id=bb3a4974&"
import script from "./WarehouseTransfer.vue?vue&type=script&lang=js&"
export * from "./WarehouseTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports